import React from "react"
import { H2 } from "@carrotfertility/carotene"
import { Spacer } from "components/views/atoms/Atoms"
import { HomeCard } from "components/views/home/Home"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"

export default function ReadAndLearnEligibilityModule(): JSX.Element {
  return (
    <HomeCard>
      <H2>Read + learn</H2>
      <Spacer height={0.25} />
      <span className="publico-text fw4 lh-copy black-80">
        Explore articles and videos on a wide range of family-forming topics.
      </span>
      <Spacer height={1} />
      <ArrowLink to="/read/Fertility">Start learning</ArrowLink>
    </HomeCard>
  )
}
